export default "__VITE_ASSET__CbFMioTL__"